module.exports = __webpack_public_path__ + "static/img/TX.6dfe72d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TX.png
// module id = UQpr
// module chunks = 1